export default "__VITE_ASSET__Cwz5i9TH__"